import CryptoJS from 'crypto-js';

export const encryptData = (data: string, key: string): string => {
    return CryptoJS.AES.encrypt(data, key).toString();
};

export const decryptData = (data: string, key: string): string => {
    var bytes  =  CryptoJS.AES.decrypt(data, key);
    return bytes.toString(CryptoJS.enc.Utf8);
};